/* ==========================================================================
   Product-card colour swatches — swap image + price + link on dot click.
   Loaded once per card via the snippet; the guard below ensures the logic
   only attaches a single time even though the tag appears many times.
   Uses event delegation so cards added later (ajax sections) still work.
   ========================================================================== */
(function () {
  if (window.__cardSwatchesInit) return;
  window.__cardSwatchesInit = true;

  function initCard(card) {
    if (card.__swatchesInit) return;
    var swatches = card.querySelector('[data-card-swatches]');
    var primary  = card.querySelector('.product-card__img--primary');
    if (!swatches || !primary) return;
    card.__swatchesInit = true;

    var link      = card.querySelector('.product-card__link');
    var titleLink = card.querySelector('.product-card__title a');
    var priceBox  = card.querySelector('.product-card__info .price');

    // Capture the page-load state so the default dot can restore it exactly.
    var orig = {
      srcset:    primary.getAttribute('srcset'),
      src:       primary.getAttribute('src'),
      width:     primary.getAttribute('width'),
      height:    primary.getAttribute('height'),
      alt:       primary.getAttribute('alt'),
      linkHref:  link      ? link.getAttribute('href')      : null,
      titleHref: titleLink ? titleLink.getAttribute('href') : null,
      priceHTML: priceBox  ? priceBox.outerHTML             : null
    };

    function setImg(srcset, src, w, h, alt) {
      if (srcset) primary.setAttribute('srcset', srcset); else primary.removeAttribute('srcset');
      if (src)    primary.setAttribute('src', src);
      if (w)      primary.setAttribute('width', w);
      if (h)      primary.setAttribute('height', h);
      if (alt != null && alt !== '') primary.setAttribute('alt', alt);
    }

    function requeryPrice() { return card.querySelector('.product-card__info .price'); }

    function apply(btn) {
      var isDefault = btn.hasAttribute('data-default');

      swatches.querySelectorAll('[data-card-swatch]').forEach(function (d) {
        var on = d === btn;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      if (isDefault) {
        setImg(orig.srcset, orig.src, orig.width, orig.height, orig.alt);
        if (link      && orig.linkHref)  link.setAttribute('href', orig.linkHref);
        if (titleLink && orig.titleHref) titleLink.setAttribute('href', orig.titleHref);
        if (priceBox  && orig.priceHTML) { priceBox.outerHTML = orig.priceHTML; priceBox = requeryPrice(); }
        card.classList.remove('is-swatch-locked');
      } else {
        setImg(btn.dataset.imgSrcset, btn.dataset.imgSrc, btn.dataset.imgWidth, btn.dataset.imgHeight, btn.dataset.imgAlt);
        if (btn.dataset.url) {
          if (link)      link.setAttribute('href', btn.dataset.url);
          if (titleLink) titleLink.setAttribute('href', btn.dataset.url);
        }
        if (priceBox && btn.dataset.priceHtml) { priceBox.outerHTML = btn.dataset.priceHtml; priceBox = requeryPrice(); }
        card.classList.add('is-swatch-locked');
      }
    }

    swatches.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-card-swatch]');
      if (btn && swatches.contains(btn)) apply(btn);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.product-card').forEach(initCard);
  }

  // Belt-and-braces: make sure a card is initialised the first time its
  // dot is clicked, even if it was injected after page load.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-card-swatch]');
    if (btn) { var c = btn.closest('.product-card'); if (c) initCard(c); }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();